import { Dropdown, type DropdownProps } from "antd";
import clsx from "clsx";
import "./BDropdown.scss";

const BDropdown = ({ className, overlayClassName, ...props }: DropdownProps) => (
  <Dropdown
    className={clsx("b-dropdown", className)}
    overlayClassName={clsx("b-dropdown__overlay", overlayClassName)}
    {...props}
  />
);

export default BDropdown;
